export const match = (matcher, collection, { idField = "id", urlField = "url_slug", titleField = "title" } = {}) => {
  if (collection.items.length === 0) {
    return [];
  }

  if (Array.isArray(matcher)) {
    return matcher.map((m) => match(m, collection, { idField, urlField, titleField })).filter((i) => !!i);
  }

  // if collection items have a `related` field, return related items
  if (typeof matcher === "object" && "related" in collection.getJsonItem()) {
    return collection
      .getItems()
      .filter(
        (i) =>
          i.related.includes(matcher[idField]) ||
          i.related.includes(matcher[urlField]) ||
          i.related.includes(matcher[titleField]),
      );
  }

  // if collection items do not have `related` field, search for a single item using matcher string
  if (typeof matcher === "string") {
    const test = matcher.trim().match(/-/g);

    // ID
    if (test && test.length === 4 && matcher.length === 36) {
      return collection.getItems().find((i) => i[idField].trim().toLowerCase() === matcher.trim().toLowerCase());
    }

    // Url Slug
    if (test && test.length > 0 && test.length < 4) {
      return collection.getItems().find((i) => i[urlField].trim().toLowerCase() === matcher.trim().toLowerCase());
    }

    // Tile
    return collection.getItems().find((i) => i[titleField].trim().toLowerCase() === matcher.trim().toLowerCase());
  }

  return null;
};
